import React from "react";
import logoBlack from "../../assets/logo-black.svg";
import { LogoutButton } from "./LogoutButton";

interface ErrorStateProps {
  message: string;
  onRetry: () => void;
}

export function ErrorState({ message, onRetry }: ErrorStateProps) {
  return (
    <div className="results results--confirmation">
      <div className="results__card results__card--confirmation">
        <img
          src={logoBlack}
          alt="De Carona com Toro"
          className="results__logo results__logo--numbers"
        />

        <h1 className="results__title results__title--confirmation">
          Ops, algo deu errado
        </h1>

        <p className="results__subtitle">{message}</p>

        <button
          type="button"
          className="btn btn--yellow results__cta"
          onClick={onRetry}
        >
          Tentar novamente
        </button>

        <LogoutButton />
      </div>
    </div>
  );
}
